
//公共库
import { Message } from "element-ui";
import { Component, Vue } from "vue-property-decorator";

//本地引入
import Pagination from "@/comp/Pagination/index.vue";
import { flowList, saveFlow, removeFlow } from "@/api/request/blogger";

//组件
@Component({
  name: "BloggerFlow",
  components: {
    Pagination,
  },
})

//界面函数
export default class extends Vue {
  //定义变量
  private list: any[] = [];
  private total: number = 0;
  private listLoading: boolean = true;

  //请求参数
  private listQuery: any = {
    //页码数据
    page: 1,
    page_size: 20,

    //临时数据
    blogger_id_str: "", //博主ID

    //请求数据
    pos: 0, //归属区域
    blogger_id: 0, //博主ID
    blogger_name: "", //博主昵称
  };

  //归属区域列表
  private posList: any[] = [
    { pos: 0, name: "全部区域" },
    { pos: 1, name: "首页" },
    { pos: 2, name: "搜索页" },
    { pos: 3, name: "广场页" },
  ];

  //创建调用
  created() {
    //获取列表
    this.getList();
  }

  //获取数据
  private async getList() {
    //显示等待
    this.listLoading = true;

    //数据赋值
    this.listQuery.blogger_id = Number(this.listQuery.blogger_id_str);

    //获取数据
    const { data } = await flowList(this.listQuery);

    //数据赋值
    this.list = data.list;
    this.total = data.total;

    //隐藏等待
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  //处理新增博主
  private addHandler(): void {
    //数据赋值
    this.form = {
      //临时变量
      sort_str: "",
      blogger_id_str: "",

      //请求数据
      id: 0, //ID
      pos: 0, //归属区域
      sort: 0, //排序
      blogger_id: 0, //博主ID
    };

    //显示界面
    this.dialogVisible = true;
    this.dialogStatus = "create";
  }

  //处理查询
  private handleSearch(): void {
    //数据赋值
    this.listQuery.page = 1;

    //获取列表
    this.getList();
  }

  //处理编辑
  private handleEdit(row: any): void {
    //数据赋值
    this.form = {
      //临时变量
      sort_str: String(row.sort),
      blogger_id_str: String(row.blogger_id),

      //请求数据
      id: row.id, //ID
      pos: row.pos, //归属区域
      sort: row.sort, //排序
      blogger_id: row.blogger_id, //博主ID
    };

    //显示界面
    this.dialogVisible = true;
    this.dialogStatus = "update";
  }

  //处理删除
  private handleDelete(row: any): void {
    //显示提示
    this.$confirm("确定删除博主流量？", "警告", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(async () => {
        //请求删除
        const res: any = await removeFlow({ id: row.id });

        //删除成功
        if (res.status == 0) {
          //显示提示
          this.$message.success("删除成功");

          //获取数据
          this.getList();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //-------------------------------- 添加/编辑 流量------------------------------
  //定义变量
  private dialogStatus: string = "";
  private dialogVisible: boolean = false;
  private dialogLoading: boolean = false;
  private dialogTitleMap: any = { update: "编辑博主流量", create: "新增博主流量" }; //对话框标题

  //表单数据
  private form: any = {
    //临时变量
    sort_str: "",
    blogger_id_str: "",

    //请求数据
    id: 0, //ID
    pos: 0, //归属区域
    sort: 0, //排序
    blogger_id: 0, //博主ID
  };

  //归属区域列表
  private posSelect: any[] = [
    { pos: 0, name: "请选择归属区域" },
    { pos: 1, name: "首页" },
    { pos: 2, name: "搜索页" },
    { pos: 3, name: "广场页" },
  ];

  //保存数据
  private async saveData() {
    //判断返回
    if (this.form.pos == 0) return Message({ message: "请选择归属区域！", type: "error", duration: 5 * 1000 });
    if (Number(this.form.sort_str) == 0) return Message({ message: "请输入排序！", type: "error", duration: 5 * 1000 });
    if (Number(this.form.blogger_id_str) == 0) return Message({ message: "请输入博主ID！", type: "error", duration: 5 * 1000 });

    //显示等待
    this.dialogLoading = true;

    //数据赋值
    this.form.sort = Number(this.form.sort_str);
    this.form.blogger_id = Number(this.form.blogger_id_str);

    //处理编辑
    await saveFlow(this.form);

    //隐藏对话框
    this.dialogVisible = false;
    this.dialogLoading = false;

    //获取列表
    this.getList();

    //显示提示
    this.$notify({
      title: "成功",
      message: "创建成功",
      type: "success",
      duration: 2000,
    });
  }
}
